module.exports = __webpack_public_path__ + "media/country_flags/bw-108a36d4.png";